// Couche analytique indépendante du fournisseur + gestion du consentement (RGPD).
// Les scripts marketing (GA4 / Meta Pixel) ne sont chargés qu'APRÈS consentement.
// Compatible avec une bannière cookies déjà présente sur WordPress : il suffit
// d'appeler setConsent(true/false) depuis cette bannière externe si besoin.

import { GA4_MEASUREMENT_ID, META_PIXEL_ID } from "../config";

const KEY = "traversee_cookie_consent";

export const getConsent = () => {
  try {
    return localStorage.getItem(KEY);
  } catch (e) {
    return null;
  }
};

export const hasConsent = () => getConsent() === "granted";

let marketingLoaded = false;

const loadMarketing = () => {
  if (marketingLoaded) return;
  marketingLoaded = true;

  // GA4
  if (GA4_MEASUREMENT_ID) {
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_MEASUREMENT_ID}`;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () {
      window.dataLayer.push(arguments);
    };
    window.gtag("js", new Date());
    window.gtag("config", GA4_MEASUREMENT_ID);
  }

  // Meta Pixel
  if (META_PIXEL_ID) {
    /* eslint-disable */
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = "2.0";
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
    /* eslint-enable */
    window.fbq("init", META_PIXEL_ID);
    window.fbq("track", "PageView");
  }
};

// Applique un choix de consentement (bannière interne ou externe WordPress)
export const setConsent = (granted) => {
  try {
    localStorage.setItem(KEY, granted ? "granted" : "denied");
  } catch (e) {
    /* ignore */
  }
  window.__consentGranted = !!granted;
  if (typeof window.gtag === "function") {
    window.gtag("consent", "update", {
      analytics_storage: granted ? "granted" : "denied",
      ad_storage: granted ? "granted" : "denied",
    });
  }
  if (granted) loadMarketing();
  track("consent_update", { granted: !!granted });
};

// À appeler au démarrage : mode consentement par défaut = refusé (RGPD)
export const initConsent = () => {
  const c = getConsent();
  window.__consentGranted = c === "granted";
  window.dataLayer = window.dataLayer || [];
  if (c === "granted") loadMarketing();
};

export const track = (event, data = {}) => {
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...data });
    if (window.__consentGranted) {
      if (typeof window.gtag === "function") window.gtag("event", event, data);
      if (typeof window.fbq === "function") window.fbq("trackCustom", event, data);
    }
  } catch (e) {
    /* silencieux */
  }
  if (process.env.NODE_ENV !== "production") {
    // eslint-disable-next-line no-console
    console.debug("[analytics]", event, data);
  }
};
